<template>
  <div class="form-group tw-mb-3">
    <label class="form-label tw-block tw-mb-0">
      Suche
      <input v-model="searchTerm" class="form-control" />
    </label>
  </div>

  <AppBrowser
    v-slot="{ results }: { results: Image[] }"
    :api-collection-endpoint="endpoint"
    :filters="{ search: debouncedSearchTerm }"
    class="tw-grid tw-gap-3 tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 tw-max-h-[50vh] lg:tw-max-h-[600px]"
  >
    <li v-for="image in results" :key="image.id">
      <AppImagePreview
        :url="image.url"
        class="tw-h-full tw-aspect-square tw-cursor-pointer tw-border tw-border-gray-200 tw-origin-center tw-transition-all tw-ring-blue-200 tw-ring-offset-2 tw-rounded tw-overflow-hidden hover:tw-z-20 hover:tw-ring-4 focus:tw-ring-4 focus:tw-outline-none"
        tabindex="0"
        @enter.stop.prevent="emit('input', image)"
        @click.stop="emit('input', image)"
      />
    </li>
  </AppBrowser>
</template>

<script lang="ts" setup>
import { refDebounced } from '@vueuse/core'
import { ref } from 'vue'
import { Image } from '../types'
import AppBrowser from './AppBrowser.vue'
import AppImagePreview from './AppImagePreview.vue'

defineProps<{
  endpoint: string
}>()
const emit = defineEmits<{
  (e: 'input', value: Image): void
}>()

const searchTerm = ref('')
const debouncedSearchTerm = refDebounced<string>(searchTerm, 300)
</script>
